import React, { useState } from "react";

import { apiURL } from "../../../src/api/index";
import { NavLink, useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";

function Login() {
  const Navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setpassword] = useState("");

  function adminLogin() {
    if (email === "" || password === "") {
      alert("please fill out the details!");
    } else {
      localStorage.setItem("adminDetails", JSON.stringify({ email, password }));

      fetch(`${apiURL}/adminlogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      })
        .then((res) => {
          const data = res.json();
          if (data) {
            Navigate("/admin/dashboard");
            console.log("login successful");
          } else {
            console.log("Invalid Details");
          }
        })
        .catch((error) => {
          console.log("server error", error);
        });
    }
  }

  return (
    <>
      <NavLink to="/">
        <div className="flex justify-center items-center absolute top-10 left-5">
          <AiOutlineArrowLeft size="20" />
          <img
            className="bg-choice"
            width="55px"
            src="/images/digitalmechanic.png"
            alt="logo"
          />
          <span className="text-xl md:text-2xl">DigitalMechanic</span>
        </div>
      </NavLink>
      <div className="font-primary flex justify-center items-center w-[88%] mx-auto h-[100vh]">
        <div className="flex text-center bg-primary text-white rounded-2xl p-10 flex-col my-10 justify-between">
          <h2 className="text-2xl font-semibold">Admin Login</h2>
          <p className="my-2 text-sm w-72 mx-auto text-center">
            Hey, Enter your details to get sign in to your Admin Account
          </p>
          <input
            className="login-input"
            type="text"
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email..."
          />
          <input
            className="login-input"
            type="password"
            name="password"
            onChange={(e) => setpassword(e.target.value)}
            placeholder="Passcode..."
          />
          <button
            className="my-2 border border-black-200 bg-secondary rounded-lg p-2 outline-none"
            onClick={adminLogin}
          >
            Dashboard
          </button>
        </div>
      </div>
    </>
  );
}

export default Login;
